export default {"src":"/_next/static/media/visa_icon.1f09f20c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};